import { render, staticRenderFns } from "./SupplierAdd.vue?vue&type=template&id=8998b814&scoped=true&"
import script from "./SupplierAdd.vue?vue&type=script&lang=js&"
export * from "./SupplierAdd.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAdd.vue?vue&type=style&index=0&id=8998b814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8998b814",
  null
  
)

export default component.exports